<template>
  <div class="page-container">
    <Sidebar />
    <div class="main-content">
      <div class="page-header">
        <h1>内容管理</h1>
        <button class="add-btn" @click="openAddModal">+ 发布内容</button>
      </div>
      
      <div class="filter-bar">
        <button :class="['filter-btn', filter === 'all' ? 'active' : '']" @click="filter = 'all'">全部</button>
        <button :class="['filter-btn', filter === 'exhibition' ? 'active' : '']" @click="filter = 'exhibition'">展会</button>
        <button :class="['filter-btn', filter === 'training' ? 'active' : '']" @click="filter = 'training'">培训</button>
        <button :class="['filter-btn', filter === 'activity' ? 'active' : '']" @click="filter = 'activity'">活动</button>
      </div>
      
      <div class="content-body">
        <div class="loading" v-if="loading">加载中...</div>
        <div class="error" v-else-if="error">{{ error }}</div>
        
        <div class="card-list" v-else>
          <div class="card" v-for="item in filteredList" :key="item.id">
            <img :src="getImageUrl(item.imageUrl)" :alt="item.title" class="card-image" />
            <div class="card-info">
              <span :class="['type-tag', item.type]">{{ getTypeName(item.type) }}</span>
              <h3>{{ item.title }}</h3>
              <p class="link">{{ item.linkUrl }}</p>
            </div>
            <div class="card-actions">
              <button class="edit-btn" @click="editItem(item)">编辑</button>
              <button class="delete-btn" @click="deleteItem(item.id)">删除</button>
            </div>
          </div>
          <div class="empty" v-if="filteredList.length === 0">暂无数据</div>
        </div>
      </div>
    </div>

    <!-- 添加/编辑弹窗 -->
    <div class="modal" v-if="showModal">
      <div class="modal-content">
        <h2>{{ editId ? '编辑内容' : '发布内容' }}</h2>
        <form @submit.prevent="submitForm">
          <div class="form-group">
            <label>类别</label>
            <select v-model="form.type" required>
              <option value="exhibition">展会</option>
              <option value="training">培训</option>
              <option value="activity">活动</option>
            </select>
          </div>
          <div class="form-group">
            <label>标题</label>
            <input type="text" v-model="form.title" required />
          </div>
          <div class="form-group">
            <label>图片（限制500KB）</label>
            <div class="upload-area">
              <input type="file" accept="image/*" @change="handleImageUpload" ref="fileInput" />
              <div class="preview" v-if="form.imageUrl">
                <img :src="form.imageUrl" />
                <button class="remove-img" @click="removeImage">×</button>
              </div>
              <p class="upload-tip" v-else>点击上传图片（最大500KB）</p>
            </div>
          </div>
          <div class="form-group">
            <label>链接地址</label>
            <input type="text" v-model="form.linkUrl" required placeholder="输入跳转链接" />
          </div>
          <div class="form-actions">
            <button type="button" class="cancel-btn" @click="closeModal">取消</button>
            <button type="submit" class="submit-btn" :disabled="uploading">{{ uploading ? '上传中...' : '提交' }}</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Sidebar from '../components/Sidebar.vue'

export default {
  name: 'ActivityList',
  components: { Sidebar },
  data() {
    return {
      list: [],
      loading: true,
      error: '',
      filter: 'all',
      showModal: false,
      editId: null,
      form: { title: '', imageUrl: '', linkUrl: '', type: 'activity' },
      uploading: false
    }
  },
  computed: {
    filteredList() {
      if (this.filter === 'all') return this.list
      return this.list.filter(item => item.type === this.filter)
    }
  },
  mounted() { this.fetchList() },
  methods: {
    async fetchList() {
      this.loading = true
      try {
        const response = await axios.get('/api/activities')
        if (response.data.code === 200) this.list = response.data.data || []
      } catch (err) { this.error = '网络错误' }
      finally { this.loading = false }
    },
    getTypeName(type) {
      const names = { exhibition: '展会', training: '培训', activity: '活动' }
      return names[type] || '活动'
    },
    getImageUrl(url) {
      if (!url) return ''
      if (url.startsWith('http')) return url
      return 'https://yaotongbao.langya1616.com' + url
    },
    openAddModal() {
      this.editId = null
      this.form = { title: '', imageUrl: '', linkUrl: '', type: 'activity' }
      this.showModal = true
    },
    editItem(item) {
      this.editId = item.id
      this.form = { title: item.title, imageUrl: item.imageUrl, linkUrl: item.linkUrl, type: item.type || 'activity' }
      this.showModal = true
    },
    closeModal() {
      this.showModal = false
      this.editId = null
      this.form = { title: '', imageUrl: '', linkUrl: '', type: 'activity' }
    },
    handleImageUpload(e) {
      const file = e.target.files[0]
      if (!file) return
      
      if (file.size > 500 * 1024) {
        alert('图片大小不能超过500KB')
        e.target.value = ''
        return
      }
      
      this.uploading = true
      const formData = new FormData()
      formData.append('file', file)
      
      axios.post('/api/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then(res => {
        if (res.data.code === 200) {
          this.form.imageUrl = res.data.data.url
        } else {
          alert('上传失败：' + res.data.msg)
        }
      }).catch(err => {
        alert('上传失败')
      }).finally(() => {
        this.uploading = false
      })
    },
    removeImage() {
      this.form.imageUrl = ''
      if (this.$refs.fileInput) this.$refs.fileInput.value = ''
    },
    async submitForm() {
      if (!this.form.imageUrl) {
        alert('请上传图片')
        return
      }
      try {
        if (this.editId) await axios.put(`/api/activities/${this.editId}`, this.form)
        else await axios.post('/api/activities', this.form)
        this.closeModal()
        this.fetchList()
      } catch (err) { alert('操作失败') }
    },
    async deleteItem(id) {
      if (!confirm('确定删除？')) return
      try { await axios.delete(`/api/activities/${id}`); this.fetchList() }
      catch (err) { alert('删除失败') }
    }
  }
}
</script>

<style scoped>
.page-container { display: flex; min-height: 100vh; background: #f5f5f5; }
.main-content { flex: 1; padding: 30px; margin-left: 260px; }
.page-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; }
.page-header h1 { font-size: 24px; color: #2c3e50; }
.add-btn { padding: 10px 20px; background: #3498db; color: white; border: none; border-radius: 5px; cursor: pointer; }
.filter-bar { display: flex; gap: 10px; margin-bottom: 20px; }
.filter-btn { padding: 8px 20px; background: white; border: 1px solid #ddd; border-radius: 5px; cursor: pointer; }
.filter-btn.active { background: #3498db; color: white; border-color: #3498db; }
.content-body { background: white; padding: 20px; border-radius: 10px; box-shadow: 0 2px 10px rgba(0,0,0,0.1); }
.loading, .error, .empty { text-align: center; padding: 50px; color: #666; }
.card-list { display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap: 20px; }
.card { border-radius: 10px; overflow: hidden; border: 1px solid #eee; }
.card-image { width: 100%; height: 150px; object-fit: cover; }
.card-info { padding: 15px; }
.type-tag { display: inline-block; padding: 2px 8px; border-radius: 3px; font-size: 12px; margin-bottom: 8px; }
.type-tag.exhibition { background: #9b59b6; color: white; }
.type-tag.training { background: #27ae60; color: white; }
.type-tag.activity { background: #e74c3c; color: white; }
.card-info h3 { margin: 0 0 8px; font-size: 16px; }
.card-info .link { color: #666; font-size: 12px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.card-actions { padding: 10px 15px; display: flex; gap: 10px; }
.edit-btn, .delete-btn { padding: 6px 12px; border: none; border-radius: 5px; cursor: pointer; font-size: 12px; }
.edit-btn { background: #3498db; color: white; }
.delete-btn { background: #e74c3c; color: white; }
.modal { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); display: flex; justify-content: center; align-items: center; z-index: 1000; }
.modal-content { background: white; padding: 30px; border-radius: 10px; width: 450px; max-height: 90vh; overflow-y: auto; }
.modal-content h2 { margin: 0 0 20px; }
.form-group { margin-bottom: 15px; }
.form-group label { display: block; margin-bottom: 5px; color: #666; }
.form-group input, .form-group select { width: 100%; padding: 10px; border: 1px solid #ddd; border-radius: 5px; }
.upload-area { border: 1px dashed #ddd; border-radius: 5px; padding: 20px; text-align: center; position: relative; }
.upload-area input[type="file"] { position: absolute; top: 0; left: 0; width: 100%; height: 100%; opacity: 0; cursor: pointer; }
.preview { position: relative; }
.preview img { max-width: 100%; max-height: 150px; }
.remove-img { position: absolute; top: 5px; right: 5px; background: #e74c3c; color: white; border: none; border-radius: 50%; width: 20px; height: 20px; cursor: pointer; }
.upload-tip { color: #999; font-size: 12px; }
.form-actions { display: flex; gap: 10px; justify-content: flex-end; margin-top: 20px; }
.cancel-btn, .submit-btn { padding: 10px 20px; border: none; border-radius: 5px; cursor: pointer; }
.cancel-btn { background: #ddd; }
.submit-btn { background: #3498db; color: white; }
.submit-btn:disabled { background: #bdc3c7; cursor: not-allowed; }
</style>